module.exports = __webpack_public_path__ + "static/CSSF Lux one pager-085e67eb2738353d5229eea5ed54e0a7.pdf";